export var FormFieldType;
(function (FormFieldType) {
    FormFieldType["Text"] = "text";
    FormFieldType["Checkbox"] = "checkbox";
    FormFieldType["Radio"] = "radio";
    FormFieldType["Link"] = "link";
    FormFieldType["DropButton"] = "drop-button";
    FormFieldType["Submit"] = "submit";
})(FormFieldType || (FormFieldType = {}));
export var ConversionType;
(function (ConversionType) {
    ConversionType["Page"] = "page";
    ConversionType["Url"] = "url";
    ConversionType["Goal"] = "goal";
})(ConversionType || (ConversionType = {}));
//# sourceMappingURL=form-types.js.map